import React from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import Screenshots from '../components/Screenshots/Screenshots';
import Features from '../components/Features/Features';
import FAQ from '../components/FAQ/FAQ';
import Footer from '../components/Footer/Footer';

const RoamrPage: React.FC = () => {
  return (
    <div className="roamr-app">
      <Header />
      <main>
        <Hero />
        <Screenshots />
        <Features />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default RoamrPage;